export const PAYMENT_METHOD_TYPES = {
  Card: 'Card',
  PayPalCredit: 'PayPalCredit',
  ApplePay: 'ApplePay',
  GooglePay: 'GooglePay',
  DirectDebit: 'DirectDebit',
  PayPal: 'PayPal',
  IDeal: 'IDeal',
  Bancontact: 'Bancontact',
  Trustly: 'Trustly',
  Vipps: 'Vipps',
  Walley: 'Walley',
  Swish: 'Swish',
  MobilePay: 'MobilePay',
}
